import React, { FunctionComponent } from 'react';

import { DeliveryMethodSelect } from 'src/components/delivery-method-select';
import { SummaryInformationCard, SummaryItem } from 'src/components/summary-information-card';
import { SummaryInformationRow } from 'src/components/summary-information-row';
import { selectSelectedServiceLocationOrThrow } from 'src/state/address/selectors';
import { selectDeliveryType } from 'src/state/order/selectors';
import { useAppSelector } from 'src/state/thunk-api';
import { useTabletMediaQuery } from 'src/utils/breakpoints-utils';
import { currencyWithSuffix } from 'src/utils/currency-utils';
import { OrderInformationUtils } from 'src/utils/order-information-utils';
import { PricingUtils } from 'src/utils/pricing-utils';
import { i18n } from 'src/i18n';
import { useProductsResponseQueryStateOrThrow } from 'src/hooks/use-products-query';

export const DeliveryInformation: FunctionComponent = () => {
  const serviceLocation = useAppSelector(selectSelectedServiceLocationOrThrow);
  const deliveryType = useAppSelector(selectDeliveryType);
  const { deliveryPricing } = useProductsResponseQueryStateOrThrow();
  const deliveryPrice = PricingUtils.getDeliveryPrice(deliveryPricing, deliveryType);

  const isOnTablet = useTabletMediaQuery();

  const summaryItems: SummaryItem[] = !isOnTablet
    ? [
        {
          label: i18n.page.summary.deliveryInformation.totalPrice,
          value: currencyWithSuffix(deliveryPrice),
        },
      ]
    : [];

  return (
    <SummaryInformationCard
      title={i18n.page.summary.deliveryInformation.title}
      content={
        <>
          <SummaryInformationRow
            label={i18n.page.summary.deliveryInformation.deliveryAddress}
            value={OrderInformationUtils.getShortAddress(serviceLocation)}
            isValueSensitive={true}
          />
          <DeliveryMethodSelect />
        </>
      }
      summaryItems={summaryItems}
    />
  );
};
